/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * request body of DELETE prtimes_media_lists.
 * @export
 * @interface DeletePrtimesMediaListsRequest
 */
export interface DeletePrtimesMediaListsRequest {
    /**
     * メディアリストIDのリスト
     * @type {Array<number>}
     * @memberof DeletePrtimesMediaListsRequest
     */
    mediaListIds: Array<number>;
}

export function DeletePrtimesMediaListsRequestFromJSON(json: any): DeletePrtimesMediaListsRequest {
    return DeletePrtimesMediaListsRequestFromJSONTyped(json, false);
}

export function DeletePrtimesMediaListsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeletePrtimesMediaListsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaListIds': json['media_list_ids'],
    };
}

export function DeletePrtimesMediaListsRequestToJSON(value?: DeletePrtimesMediaListsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_list_ids': value.mediaListIds,
    };
}

